import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import DestinationFullMap from './components/DestinationFullMap'
import store from 'js/store';

const el = document.querySelector('.destination-full-map');

if (el) {
  const root = createRoot(el);

  root.render(
    <Provider store={store}>
      <DestinationFullMap />
    </Provider>
  )
}
